import { render, staticRenderFns } from "./documento_atestado.vue?vue&type=template&id=1eb7f464&scoped=true&"
import script from "./documento_atestado.vue?vue&type=script&lang=js&"
export * from "./documento_atestado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb7f464",
  null
  
)

export default component.exports